// extracted by mini-css-extract-plugin
module.exports = {"headline":"styles_headline__TdWRV","label":"styles_label__z5mmJ","caption":"styles_caption__Ogzym","description":"styles_description__zcSxB","content":"styles_content__p9FyX"};